var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100%"}},[_c('div',{staticStyle:{"height":"3.75rem"}},[_c('NavList')],1),_c('router-view',{staticStyle:{"min-height":"64.7vh"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }